import { Component, ElementRef, EventEmitter, HostListener, Input, Output } from '@angular/core';

@Component({
  selector: 'app-file-card',
  styleUrls: ['./file-card.component.scss'],
  templateUrl: './file-card.component.html',
})
export class FileCardComponent {
  @Input() fileName!: string;
  @Input() cardName: string = '';
  @Input() file!: File;
  @Output() fileDeleted = new EventEmitter<{ file: File, card: string }>();


  menuOpen = false;

  /**
   *
   */
  constructor(private eRef: ElementRef) {
    
  }

  get fileExtension(): string {
    return this.fileName?.split('.').pop()?.toLowerCase() ?? '';
  }

get extensionColor(): string {
  const ext = this.fileExtension.toLowerCase();

  if (['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'svg'].includes(ext)) {
    return 'bg-purple-500'; // 🖼️ Images
  }

  switch (ext) {
    case 'pdf':
      return 'bg-red-500'; // 📄 PDF
    case 'doc':
    case 'docx':
      return 'bg-blue-600'; // 📄 Word
    case 'xls':
    case 'xlsx':
      return 'bg-green-600'; // 📊 Excel
    case 'ppt':
    case 'pptx':
      return 'bg-orange-500'; // 📊 PowerPoint
    case 'txt':
      return 'bg-gray-500'; // 📄 Text
    case 'zip':
    case 'rar':
    case '7z':
      return 'bg-indigo-500'; // 🗃️ Archives
    case 'csv':
      return 'bg-teal-600'; // 📊 CSV
    case 'json':
      return 'bg-pink-500'; // ⚙️ JSON
    case 'html':
    case 'xml':
      return 'bg-yellow-600'; // 🔤 Markup
    default:
      return 'bg-gray-400'; // Generic fallback
  }
}


  get extensionLabel(): string {
    return this.fileExtension.toUpperCase();
  }

  toggleMenu() {
    this.menuOpen = !this.menuOpen;
  }

  downloadFile(): void {
  const fileToDownload = this.file; // exemple avec "Devis"

  const url = URL.createObjectURL(fileToDownload);
  const a = document.createElement('a');
  a.href = url;
  a.download = fileToDownload.name;
  a.click();
  URL.revokeObjectURL(url);
}


  deleteFile() {
    this.fileDeleted.emit({ file: this.file, card: this.cardName });
  }

    @HostListener('document:click', ['$event'])
  clickOutside(event: Event) {
    if (!this.eRef.nativeElement.contains(event.target)) {
      this.menuOpen = false;
    }
  }
}
